import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Owner-only images travel with the session headers, so they are fetched as blobs and shown through an object URL
// (the browser's HTTP cache still honours the server's ETag / max-age). `enabled=false` defers the fetch (lazy).
export const useAuthedBlobUrl = (path, enabled = true) => {
  const [state, setState] = useState({ src: null, error: false, loading: false });
  useEffect(() => {
    if (!path || !enabled) return undefined;
    let alive = true;
    let objectUrl = null;
    setState({ src: null, error: false, loading: true });
    api
      .get(path, { responseType: "blob" })
      .then((r) => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(r.data);
        setState({ src: objectUrl, error: false, loading: false });
      })
      .catch(() => alive && setState({ src: null, error: true, loading: false }));
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, enabled]);
  return state;
};

// True once the element has been near the viewport (200 px margin) — and immediately where IntersectionObserver is missing.
export const useNearViewport = () => {
  const ref = useRef(null);
  const [near, setNear] = useState(typeof IntersectionObserver === "undefined");
  useEffect(() => {
    const el = ref.current;
    if (near || !el || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver((entries) => entries.some((e) => e.isIntersecting) && setNear(true), { rootMargin: "200px" });
    io.observe(el);
    return () => io.disconnect();
  }, [near]);
  return [ref, near];
};
